import { combineReducers } from 'redux'

import { routerReducer } from 'react-router-redux'

import auth from './authReducer'
import player from './playerReducer'
import overlay from './overlayReducer'
import messages from './messagesReducer'
import messageOverlay from './messageOverlayReducer'
import confirm from './confirmReducer'
import menu from './menuReducer'
import settings from './settingsReducer'

export default combineReducers({
    auth,
    player,
    overlay,
    messages,
    messageOverlay,
    confirm,
    menu,
    settings,
    router:routerReducer
})



// WEBPACK FOOTER //
// ./src/store/reducers/index.js